import { checkAuthentication } from '@jira/spa-apps__interceptors/src/checkAuthentication.tsx';
import { createResourceError } from '@jira/router-resources__utils/src/createResourceError.tsx';
import { MIN_MAX_AGE } from '@jira/router-resources__utils/src/minMaxAge.constants.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import {
	type RouterDataContext,
	createResource,
	type RouterContext,
	type ResourceStoreContext,
	type RouteResource,
} from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_ADVANCED_ROADMAPS_REPORT_SOURCE_PLAN } from './resourceTypePlansBacklog.constants.tsx';
import type { ReportSourcePlan } from './ReportSourcePlan.types.tsx';

/**
 * Resolves a report hash to the plan and scenario the report was created from, so a legacy report
 * URL can be redirected to its source timeline.
 */
export const advancedRoadmapsPlanReportSourcePlanResource: RouteResource<ReportSourcePlan> =
	createResource<ReportSourcePlan>({
		type: RESOURCE_TYPE_ADVANCED_ROADMAPS_REPORT_SOURCE_PLAN,
		getKey: ({ match }: RouterContext) =>
			`planReportSourcePlan_${match.params.reportId == null ? '' : match.params.reportId}`,
		getData: async ({ match }: RouterDataContext, { tenantContext }: ResourceStoreContext) => {
			if (!checkAuthentication(tenantContext)) {
				throw createResourceError({
					component: 'router-resources.advanced-roadmaps-plan.report-source-plan.get-data',
					message: 'Current user is not authenticated',
					name: 'AuthenticationError',
					skipSentry: true,
				});
			}
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			const earlyPreloadPromise = window.__ARJ_BASIC_PLAN_INFO_FOR_REPORT_PROMISE__;
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			delete window.__ARJ_BASIC_PLAN_INFO_FOR_REPORT_PROMISE__;

			const { reportId } = match.params;
			const response = await (earlyPreloadPromise ??
				performGetRequest(`/rest/jpo/1.0/reportinfo/generic/${reportId == null ? '' : reportId}`));

			return {
				planId: response?.planId ?? null,
				scenarioId: response?.scenarioId ?? null,
			};
		},
		maxAge: MIN_MAX_AGE,
	});
